import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './loader.js';

const listItemMetaCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;color:var(--jw-theme-surface-text-helper-color);display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.5rem .75rem;text-align:center}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";
const WuiListItemMetaStyle0 = listItemMetaCss;

const WuiListItemMeta = /*@__PURE__*/ proxyCustomElement(class WuiListItemMeta extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
        this.loading = false;
    }
    render() {
        return (
        // biome-ignore lint/a11y/useSemanticElements: custom element
        h(Host, { key: '366c3c8133d5b7b2865448611619db117f9a373e', role: "listitem", tabIndex: -1 }, this.loading ? h("wui-loader", { type: "dots" }) : this.label));
    }
    static get style() { return WuiListItemMetaStyle0; }
}, [1, "wui-list-item-meta", {
        "label": [1],
        "loading": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-meta", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemMeta);
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemMeta as W, defineCustomElement as d };

//# sourceMappingURL=list-item-meta.js.map